/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventStatusEnum } from './EventStatusEnum';
import {
    EventStatusEnumFromJSON,
    EventStatusEnumFromJSONTyped,
    EventStatusEnumToJSON,
    EventStatusEnumToJSONTyped,
} from './EventStatusEnum';

/**
 * Emission Event serializer used for update operations.
 * @export
 * @interface EmissionEventUpdateRequest
 */
export interface EmissionEventUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof EmissionEventUpdateRequest
     */
    site?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmissionEventUpdateRequest
     */
    equipment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmissionEventUpdateRequest
     */
    mainEvent?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EmissionEventUpdateRequest
     */
    responsible?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EmissionEventUpdateRequest
     */
    notifyResponsible?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EmissionEventUpdateRequest
     */
    reviewer?: number | null;
    /**
     * 
     * @type {EventStatusEnum}
     * @memberof EmissionEventUpdateRequest
     */
    eventStatus: EventStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EmissionEventUpdateRequest
     */
    extraNotes?: string;
    /**
     * 
     * @type {any}
     * @memberof EmissionEventUpdateRequest
     */
    formData?: any | null;
}



/**
 * Check if a given object implements the EmissionEventUpdateRequest interface.
 */
export function instanceOfEmissionEventUpdateRequest(value: object): value is EmissionEventUpdateRequest {
    if ((!('eventStatus' in (value as Record<string, any>)) && !('event_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['eventStatus'] === undefined && (value as Record<string, any>)['event_status'] === undefined)) return false;
    return true;
}

export function EmissionEventUpdateRequestFromJSON(json: any): EmissionEventUpdateRequest {
    return EmissionEventUpdateRequestFromJSONTyped(json, false);
}

export function EmissionEventUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmissionEventUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'site': json['site'] === undefined ? undefined : json['site'] === null ? null : json['site'],
        'equipment': json['equipment'] === undefined ? undefined : json['equipment'] === null ? null : json['equipment'],
        'mainEvent': json['main_event'] === undefined ? undefined : json['main_event'] === null ? null : json['main_event'],
        'responsible': json['responsible'] === undefined ? undefined : json['responsible'] === null ? null : json['responsible'],
        'notifyResponsible': json['notify_responsible'] == null ? undefined : json['notify_responsible'],
        'reviewer': json['reviewer'] === undefined ? undefined : json['reviewer'] === null ? null : json['reviewer'],
        'eventStatus': EventStatusEnumFromJSON(json['event_status']),
        'extraNotes': json['extra_notes'] == null ? undefined : json['extra_notes'],
        'formData': json['form_data'] === undefined ? undefined : json['form_data'] === null ? null : json['form_data'],
    };
}

export function EmissionEventUpdateRequestToJSON(json: any): EmissionEventUpdateRequest {
    return EmissionEventUpdateRequestToJSONTyped(json, false);
}

export function EmissionEventUpdateRequestToJSONTyped(value?: EmissionEventUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site': value['site'],
        'equipment': value['equipment'],
        'main_event': value['mainEvent'],
        'responsible': value['responsible'],
        'notify_responsible': value['notifyResponsible'],
        'reviewer': value['reviewer'],
        'event_status': EventStatusEnumToJSON(value['eventStatus']),
        'extra_notes': value['extraNotes'],
        'form_data': value['formData'],
    };
}

